import React, {  useState, useEffect } from "react";
import { Collapse } from "reactstrap";
import { formatMoney } from "accounting";
import WithTotals from "./WithTotals";
import { branch, renderNothing, compose, setDisplayName } from "recompose";
import Icon from "@fortawesome/react-fontawesome";
import useNegativeTotalAdvice from "./useNegativeTotalAdvice";

const ExpressAmount = compose(
  setDisplayName("ExpressAmount"),
  branch(
    ({ confirmed, express, completed, showExpress }) =>
      !((confirmed || completed) && express && showExpress),
    renderNothing
  )
)(({ expressAmount }) => (
  <div className="col">
    Express Fee: <b>{formatMoney(expressAmount)}</b>
  </div>
));

const DiscountAmount = compose(
  setDisplayName("DiscountAmount"),
  branch(
    ({ totalDiscount, showDiscount }) => !(showDiscount && totalDiscount > 0),
    renderNothing
  )
)(({ totalDiscount }) => (
  <div className="col-2 col-md-2 col-sm-2">
    Discount: <b>-{formatMoney(totalDiscount)}</b>
  </div>
));

const Totals = ({
  totalParts,
  totalHours,
  totalFlatFee,
  title,
  subTotal,
  expressAmount,
  finalTotal,
  confirmed,
  completed,
  appliedDiscount,
  express,
  totalDiscount,
  showDiscount,
  showExpress,
  isMain, 
  role,
  items,
  contract,
  taxRate
}) => {
  const [toggledOn, setToggledOn] = useState(true);
  const [ contractTotal, setContractTotal ] = useState(0);
  const [ taxTotal, setTaxTotal ] = useState(0);

  const toggle = () => {
    setToggledOn(!toggledOn);
  };

  const total_cost_contract = () => {
    if (contract.aasm_state === "waiting_for_payment") {
      return formatMoney(contract.total_cost_contract)
    }

    return contractTotal < 0 ?
      formatMoney(0) :
      formatMoney(contractTotal + taxTotal)
  }

  useEffect(() => {
    function estimateTaxesTotal(){
      const taxableItemsArray = items.filter(obj => { return obj.taxable === true })
      let initialValue = 0
      let sum = taxableItemsArray.reduce(function (accumulator, currentValue) {
          if (currentValue.type_service === "for_hours"){
            let laborFee = currentValue.labor_time ? parseFloat(contract.labor_rate) * parseFloat(currentValue.labor_time) : 0
            let partsFee = currentValue.part_price ? parseFloat(currentValue.part_price) : 0
            return accumulator + partsFee + laborFee
          } else {
            return accumulator + parseFloat(currentValue.flat_fee) 
          }
      }, initialValue)
      const taxes = Math.round((sum * parseFloat(taxRate/100) + Number.EPSILON) * 100) / 100
      setTaxTotal(taxes)
    }

    function estimateContractTotal (){
      let sum = items.reduce(function (accumulator, currentValue) {
          if (currentValue.type_service === "for_hours"){
            let laborFee = currentValue.labor_time ? parseFloat(contract.labor_rate) * parseFloat(currentValue.labor_time) : 0
            let partsFee = currentValue.part_price ? parseFloat(currentValue.part_price) : 0
            return accumulator + partsFee + laborFee
          } else {
            return accumulator + parseFloat(currentValue.flat_fee) 
          }
      }, 0)
      setContractTotal(sum)
    }

    estimateTaxesTotal()
    estimateContractTotal()
  }, [items, taxRate, contract.labor_rate])

  useNegativeTotalAdvice({ subTotal, finalTotal, isMain });

  return (
    <div className="total-info row pb-3">
      <div className="col-md-12">
        {title && (
          <>
            <div className="col-auto" onClick={toggle}>
              <h4 className="text-info">
                {title}{" "}
                <Icon icon={toggledOn ? "chevron-up" : "chevron-down"} />
              </h4>
            </div>
          </>
        )}
      </div>
      <Collapse isOpen={toggledOn} className="row">
      <div className="col">
        Labor Total: <b>{formatMoney(totalHours)}</b>
      </div>
      <div className="col">
        Parts Total: <b>{formatMoney(totalParts)}</b>
      </div>
      <div className="col">
        Flat Costs: <b>{formatMoney(totalFlatFee)}</b>
      </div>
      <div className="col">
        Taxes Total: <b>{formatMoney(taxTotal)}</b>
      </div>
      <ExpressAmount
        confirmed={confirmed}
        completed={completed}
        expressAmount={expressAmount}
        express={express}
        showExpress={showExpress}
      />
      {finalTotal < 0 ||
      totalDiscount > finalTotal 
      // || appliedDiscount === false 
      ? null : (
        <DiscountAmount
          showDiscount={showDiscount}
          totalDiscount={totalDiscount}
        />
      )}
      <div className="col">
        <label>
          Total:{" "}
          <b>{total_cost_contract()}</b>
        </label><br/>
      </div>
      </Collapse>
    </div>
  );
};

export default WithTotals(Totals);
